<div class="search-container">
  <div class="close" (click)="closeOverlay()">
    <button mat-icon-button aria-label="Close" class="close-icon">
      <mat-icon class="icon" svgIcon="close"></mat-icon>
    </button>
  </div>
  <div class="search">
    <gc-search-input
      [autofocus]="true"
      [formControl]="searchBar"
      placeholder="{{ 'can_we_help_you_find_something' | translate }}"
    ></gc-search-input>
  </div>
  <ng-container *ngIf="results$ | async as results">
    <h3 *ngIf="searchTerm; else suggestions">{{ 'we_found_these_results' | translate }}</h3>
    <ng-template #suggestions>
      <h3>{{ 'here_are_some_suggestions' | translate }}</h3>
    </ng-template>
    <div class="results">
      <div *ngFor="let result of results">
        <ng-container [ngSwitch]="result.type">
          <div *ngSwitchCase="'doctor'">
            <div class="doctor rounded">
              <gc-doctor-card [doctor]="result.item" [minimal]="true"></gc-doctor-card>
            </div>
          </div>
          <div *ngSwitchCase="'route'">
            <div class="navigation-card">
              <mat-card>
                <mat-card-content class="phrase-group">
                  <mat-icon [svgIcon]="result.item.icon" class="icon"></mat-icon>
                  <div class="text">
                    {{ result.item.phrase | translate }}
                  </div>
                  <button mat-mini-fab aria-label="Go" class="more-button" [routerLink]="result.item.path" (click)="closeOverlay()">
                    <mat-icon svgIcon="chevron-right"></mat-icon>
                  </button>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
  <div class="help">
    <span>{{ 'not_what_you_were_looking_for' | translate }}</span>
    <button routerLink="/contact-us" mat-stroked-button aria-label="Contact Us" class="contact-button">
      <mat-icon svgIcon="comment-question"></mat-icon>
      {{ 'ask_us_directly' | translate }}
    </button>
  </div>
</div>
